export function requestNotificationPermission(): Promise<NotificationPermission> {
    // 检查浏览器支持
    if (!('Notification' in window)) {
        // console.warn('当前浏览器不支持通知');
        return Promise.resolve('denied');
    }

    // 已授权？
    if (Notification.permission === 'granted') {
        return Promise.resolve('granted');
    }

    // 已拒绝？
    if (Notification.permission === 'denied') {
        return Promise.resolve('denied');
    }

    // 请求授权（必须由用户交互触发！）
    return Notification.requestPermission();
}

export function showNotification(title: string, options?: NotificationOptions) {
    if (Notification.permission !== 'granted') {
        // console.warn('未获得通知权限');
        return;
    }

    try {
        new Notification(title, {
            ...options,
            // 推荐设置图标（相对路径或绝对 URL）
            icon: '/favicon.ico',
        });
    } catch (error) {
        // console.error('通知创建失败:', error);
    }
}